import React from 'react'

const WhoWeAre = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0)
  },[])
  return (
    <div className='app'>WhoWeAre</div>
  )
}

export default WhoWeAre